import getCookieOrMeta from '../../storage/getCookieOrMeta';
import getMeta from '../../storage/getMeta';
import { pushLeadCreated } from '../../tracking/send_to_gtm';
import compactObject from '../../util/compactObject';
import getFieldValue from '../elements/getFieldValue';
import getForm from '../elements/getForm';
import { validateCreateContact } from '../validation/submitValidation';
import getMessageValue, { getAdditionalFormFields } from './getMessageValue';
import getPageValue from './getPageValue';
import submitForm from './submitForm';
import trackFormWizardSubmissionEvents from './trackFormWizardSubmissionEvents';


function getFormUrl() {
  return `https://${process.env.API_HOST}/v1/contact/requests`;
}

function getAbTestFields() {
  const experiment = getMeta('ab-test-experiment');
  const variant = getMeta('ab-test-variant');

  if (!experiment || !variant) {
    return {};
  }

  return {
    ab_test_name: experiment,
    ab_test_variant: variant.replace(`${experiment}-`, ''),
  };
}

function getFormData(form) {
  return {
    data: compactObject({
      name: {
        full_name: getFieldValue(form, 'full_name').trim(),
      },
      contact_details: compactObject({
        email: getFieldValue(form, 'email'),
        phone: getFieldValue(form, 'phone_number'),
        dialer_consent_accepted: getFieldValue(form, 'dialer_consent_accepted'),
      }),
      location: {
        country_code: getFieldValue(form, 'country_code') || 'US',
        zip_code: getFieldValue(form, 'zip_code'),
      },
      tutoring_preferences: {
        types:
          getFieldValue(form, 'tutoring-type') ||
          getFieldValue(form, 'tutoring_type'),
        subjects: getFieldValue(form, 'subjects'),
      },
      page: getPageValue(form),
      message: getMessageValue(form),
      referer: getCookieOrMeta('referer') || '',
      referred_by_url: getFieldValue(form, 'referred_by_url'),
      landing_page: getCookieOrMeta('landing_page'),
      visitor_id: getCookieOrMeta('visitor-id'),
      callback_time:
        getFieldValue(form, 'time_to_call') ||
        getFieldValue(form, 'callback_time'),
      primary_language: getFieldValue(form, 'primary_language'),
      ...getAbTestFields(),
      ...getAdditionalFormFields(form),
    }),
  };
}

const saveCorrelationId = (step, json) => {
  step.innerHTML = `<input type="hidden" name="correlation_id" value="${json.correlationId}"/>`;
  return json;
};

export default async function createContact(step) {
  const form = getForm(step);
  const formData = getFormData(form);
  const formVersion = getFieldValue(form, 'leadform');
  const url = getFormUrl();

  validateCreateContact(formData);

  const promise = submitForm(url, { formData, formVersion }, 'POST', {
    credentials: 'include',
  }).then((json) => {
    saveCorrelationId(step, json);
    pushLeadCreated(form, { lead_type: 'nsp_form--create_contact' });
  });

  return trackFormWizardSubmissionEvents(promise, step, 'lead_creation');
}
